import * as angular from "angular";
import {IController} from "angular";
import * as _ from 'lodash';

export class PlanningResourcesFiltersPanelCtrl implements IController {
  isDraft: any;
  skills: any;
  serviceAreaIds: any;
  branchIds: string[];
  vehicleTypes: string[];
  labels: string[];
  inRoute: any;
  onFiltersChange: Function;

  /* @ngInject */
  constructor(private $mdPanel) {
  }

  /////////////////////////////////////////////////////////////////////////

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_END,
        this.$mdPanel.yPosition.ALIGN_TOPS // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.planning-resources-filters-btn')
      .withAnimation(this.$mdPanel.animation.FADE);

    const config = {
      locals: {
        data: {
          isDraft: this.isDraft,
          skills: this.skills || [],
          serviceAreaIds: this.serviceAreaIds || [],
          labels: this.labels || [],
          branchIds: this.branchIds || [],
          vehicleTypes: this.vehicleTypes || [],
          inRoute: this.inRoute,
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: DeliveriesPanelCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/planning/components/planning-resources-filters-panel/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel, reason) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(filterConfig, parentScope) {
    parentScope.onFiltersChange({
      skills: filterConfig.skills,
      serviceAreaIds: filterConfig.serviceAreaIds,
      inRoute: filterConfig.inRoute,
      branchIds: filterConfig.branchIds,
      labels: filterConfig.labels,
      vehicleTypes: filterConfig.vehicleTypes
    })
  }

}

class DeliveriesPanelCtrl implements IController {

  private siteId: any;
  private isDraft: any;
  private filterConfig: any;

  hasNoFilters: boolean = true;

  constructor(private mdPanelRef) {
    this.siteId = mdPanelRef.config.locals.data.siteId;
    this.isDraft = mdPanelRef.config.locals.data.isDraft;
  }

  $onInit() {
    this.filterConfig = {
      skills: this.mdPanelRef.config.locals.data.skills,
      serviceAreaIds: this.mdPanelRef.config.locals.data.serviceAreaIds,
      branchIds: this.mdPanelRef.config.locals.data.branchIds,
      inRoute: this.mdPanelRef.config.locals.data.inRoute,
      labels: this.mdPanelRef.config.locals.data.labels,
      vehicleTypes: this.mdPanelRef.config.locals.data.vehicleTypes
    };
    this.hasNoFilters = this._hasNoFilters();
  }

  onChangeSkills(selectedSkills) {
    this.filterConfig.skills = selectedSkills;
    this.hasNoFilters = this._hasNoFilters();
  }

  onChangeServiceAreasIds(serviceAreaIds) {
    this.filterConfig.serviceAreaIds = serviceAreaIds;
    this.hasNoFilters = this._hasNoFilters();
  }

  onChangeBranches(branchIds) {
    this.filterConfig.branchIds = branchIds;
    this.hasNoFilters = this._hasNoFilters();
  }

  onChangeLabels(labels) {
    this.filterConfig.labels = labels;
    this.hasNoFilters = this._hasNoFilters();
  }

  onChangeVehicleTypes(vehicleTypes) {
    this.filterConfig.vehicleTypes = vehicleTypes;
    this.hasNoFilters = this._hasNoFilters();
  }

  onReset() {
    this.filterConfig = {
      skills: [],
      serviceAreaIds: [],
      branchIds: [],
      labels: [],
      inRoute: undefined,
      vehicleTypes: []
    };
    this.submit()
  }

  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.filterConfig, this.mdPanelRef.config.locals.data.parentScope);
    })
  }

  cancel() {
    this.mdPanelRef.close();
  }

  private _hasNoFilters() {
    return !_.get(this.filterConfig.skills, 'length') &&
      !_.get(this.filterConfig.serviceAreaIds, 'length') &&
      !_.get(this.filterConfig.branchIds, 'length') &&
      !_.get(this.filterConfig.labels, 'length') &&
      !_.get(this.filterConfig.vehicleTypes, 'length') &&
      _.isUndefined(this.filterConfig.inRoute);
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningResourcesFiltersPanel', {
    bindings: {
      isDraft: '@?',
      skills: '<',
      serviceAreaIds: '<',
      branchIds: '<',
      vehicleTypes: '<',
      labels: '<',
      inRoute: '<',
      onFiltersChange: '&'
    },
    template: require('./planning-resources-filters-panel.html').default,
    controller: PlanningResourcesFiltersPanelCtrl
  });
